// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
}

export { isObject };
//# sourceMappingURL=isObject.esm.js.map
